module.exports = __webpack_public_path__ + "static/img/5-title.8fb4367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/5-title.png
// module id = 4AdI
// module chunks = 0